export default __webpack_public_path__ + "static/media/cross.ea390985.svg";